var React = require('react');

function Boiler (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.0418 17.3335H5.9585V22.7502H20.0418V17.3335Z","fill":"#0A9828","key":0}),React.createElement("path",{"opacity":"0.3","d":"M5.9585 3.25V17.3333H20.0418V3.25H5.9585ZM16.7918 15.1667H9.2085V10.8333H16.7918V15.1667Z","fill":"#0A9828","key":1}),React.createElement("path",{"d":"M11.3753 14.0832C11.9736 14.0832 12.4587 13.5981 12.4587 12.9998C12.4587 12.4015 11.9736 11.9165 11.3753 11.9165C10.777 11.9165 10.292 12.4015 10.292 12.9998C10.292 13.5981 10.777 14.0832 11.3753 14.0832Z","fill":"#0A9828","key":2}),React.createElement("path",{"d":"M14.6253 14.0832C15.2236 14.0832 15.7087 13.5981 15.7087 12.9998C15.7087 12.4015 15.2236 11.9165 14.6253 11.9165C14.027 11.9165 13.542 12.4015 13.542 12.9998C13.542 13.5981 14.027 14.0832 14.6253 14.0832Z","fill":"#0A9828","key":3})]);
}

Boiler.defaultProps = {"viewBox":"0 0 26 26","fill":"none"};

module.exports = Boiler;

Boiler.default = Boiler;
